
const colors = {
    YELLOW: "#FFD700",
    GREEN: "#008000",
    ORANGE: "#FFA500",
    RED: "#FF0000"
  };
  export default colors;